module.exports = __webpack_public_path__ + "img/big-classify-002.3bc4e6c0.png";